import Icon from '../../../components/AppIcon';

const WidgetLibrary = ({ onWidgetDragStart }) => {
  const widgetTypes = [
    {
      type: 'chart',
      title: 'Bar Chart',
      icon: 'BarChart3',
      description: 'Compare values across categories',
    },
    {
      type: 'chart',
      title: 'Line Chart',
      icon: 'TrendingUp',
      description: 'Show trends over time',
    },
    {
      type: 'chart',
      title: 'Pie Chart',
      icon: 'PieChart',
      description: 'Display proportional data',
    },
    {
      type: 'table',
      title: 'Data Table',
      icon: 'Table',
      description: 'Detailed tabular data view',
    },
    {
      type: 'kpi',
      title: 'KPI Card',
      icon: 'Activity',
      description: 'Key performance indicators',
    },
    {
      type: 'map',
      title: 'Geographic Map',
      icon: 'Map',
      description: 'Location-based visualization',
    },
  ];

  return (
    <div className="space-y-2">
      <h4 className="text-sm font-semibold text-foreground px-3 py-2">Widget Library</h4>
      {widgetTypes?.map((widget, index) => (
        <div
          key={index}
          draggable
          onDragStart={() => onWidgetDragStart(widget)}
          className="p-3 rounded-lg bg-card border border-border hover:border-primary/50 hover:shadow-sm cursor-move transition-all duration-200"
        >
          <div className="flex items-center gap-3 mb-2">
            <div className="w-8 h-8 rounded bg-primary/10 flex items-center justify-center">
              <Icon name={widget?.icon} size={16} color="var(--color-primary)" />
            </div>
            <h5 className="font-medium text-sm text-foreground">{widget?.title}</h5>
          </div>
          <p className="text-xs text-muted-foreground">{widget?.description}</p>
        </div>
      ))}
    </div>
  );
};

export default WidgetLibrary;